import { render, staticRenderFns } from "./display-field-row-details.vue?vue&type=template&id=71a8af24&scoped=true&"
import script from "./display-field-row-details.ts?vue&type=script&lang=ts&"
export * from "./display-field-row-details.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-row-details.scss?vue&type=style&index=0&id=71a8af24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8af24",
  null
  
)

export default component.exports